import { render, staticRenderFns } from "./allocate-table-all.vue?vue&type=template&id=1a91ef7e&"
import script from "./allocate-table-all.vue?vue&type=script&lang=js&"
export * from "./allocate-table-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports